import { useEffect, useRef } from 'react'
import { cn } from '@/lib/utils'

/** HTML önizleme — dangerouslySetInnerHTML kullanmadan sandboxed iframe. */
export function SafeHtmlFrame({
  html,
  className,
  fontFamily,
  fontSize,
}: {
  html: string
  className?: string
  fontFamily?: string
  fontSize?: number
}) {
  const ref = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const frame = ref.current
    if (!frame) return
    const doc = frame.contentDocument
    if (!doc) return
    const styles = getComputedStyle(document.documentElement)
    const fg = styles.getPropertyValue('--foreground').trim() || '0.21 0.02 265'
    const muted = styles.getPropertyValue('--muted-foreground').trim() || '0.52 0.02 265'
    doc.open()
    doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/><style>
      html,body{margin:0;padding:0;background:transparent;color:oklch(${fg});
        font:${fontSize ?? 11}px/${1.5} ${fontFamily ?? 'Arial, Helvetica, sans-serif'};word-break:break-word}
      a{color:inherit;text-decoration:underline}
      p{margin:0 0 0.5em}
      ul,ol{margin:0.4em 0;padding-left:1.25rem}
      strong{font-weight:700}
      em{font-style:italic}
      u{text-decoration:underline}
      .muted{color:oklch(${muted})}
    </style></head><body>${html}</body></html>`)
    doc.close()
    const resize = () => {
      if (!frame.contentDocument?.body) return
      frame.style.height = `${Math.max(frame.contentDocument.body.scrollHeight + 4, 24)}px`
    }
    resize()
    const obs = new ResizeObserver(resize)
    if (frame.contentDocument.body) obs.observe(frame.contentDocument.body)
    return () => obs.disconnect()
  }, [html, fontFamily, fontSize])

  return (
    <iframe
      ref={ref}
      title="html-preview"
      sandbox=""
      className={cn('w-full border-0', className)}
      style={{ minHeight: 24 }}
    />
  )
}
